import React from "react";
import NextButton from "../NextButton";
import PreviousButton from "../PreviousButton";
import ProgressBar from "../ProgressBar";
import ChannelInput from "./ManualSocialEntryInput";

const Step = ({
  prevStep,
  nextStep,
  onUserSignUpByStep,
  currentStep,
  totalSteps,
  connectedChannels,
}) => {
  return (
    <div className="w-full">
      <div>
        <h1 className="my-4 text-2xl md:text-3xl font-bold tracking-tight text-primary-700 flex items-center justify-start">
          <span>Social Platforms</span>
        </h1>
        <p className="mt-2 text-sm text-primary-700">
          Manually enter your social channels to get started with MagicLinks.
          The more channels you connect with, the more likely you are to be
          spotted for potential campaigns.
        </p>
      </div>
      <div className="mt-8">
        <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />
        <form action="#" method="POST" className="space-y-6">
          <div className="space-y-4">
            <ChannelInput
              platform="YouTube"
              channel={connectedChannels?.find((c) => c.channel === "YouTube")}
            />
            <ChannelInput
              platform="Instagram"
              channel={connectedChannels?.find(
                (c) => c.channel === "Instagram"
              )}
            />
            <ChannelInput
              platform="TikTok"
              channel={connectedChannels?.find((c) => c.channel === "TikTok")}
            />
          </div>
          <div className="w-full flex justify-between">
            <PreviousButton onClick={prevStep} />
            <NextButton
              disabled={!connectedChannels?.length}
              onClick={() => {
                onUserSignUpByStep(nextStep);
              }}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Step;
